import saveAs from 'file-saver'
import { string } from 'joi'
import { ResultFileDownloadResponse } from '../types'
// import { createBrowserHistory } from 'react-router-dom'

export type OptionsFormat = {
  valueField: string
  displayField: string
}

export const formatOptions = (
  data: Record<string, unknown>[],
  valueField: string,
  displayField: string
) => {
  if (Array.isArray(data)) {
    return data.map(obj => {
      const formattedOption = {}

      for (const [key, value] of Object.entries(obj)) {
        key === valueField && (formattedOption['valueField'] = value)

        key === displayField && (formattedOption['displayField'] = value)
      }

      return formattedOption
    })
  } else {
    return []
  }
}

export interface Map {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

export const getFileSize = (bytes: number, decimals = 2): string => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const downloadFile = async (
  data: string | Blob,
  fileName: string,
  contentType = 'text/plain'
//): Promise<ResultFileDownloadResponse[]> => {
): Promise<void> => { //fix types - no functional change
  if (data instanceof string || typeof data === 'string') {
    data = b64toBlob(data as string, contentType)
  }
  return saveAs(data, fileName)
}

export const compare = (a: number, b: number): 0 | 1 | -1 => {
  if (a < b) {
    return -1
  }
  if (a > b) {
    return 1
  }
  return 0
}

const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data)
  const byteArrays: Uint8Array[] = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}

export const capitalizeFirstLetter = (s: string): string => {
  return s.toString().charAt(0).toUpperCase() + s.slice(1)
}

export const hasInvalidField = async (
  valid: string[],
  received: string[]
): Promise<{
  isInvalid: boolean
  fields: {
    field: string
    message: string
  }[]
}> => {
  const invalidFields = received.filter(item => !valid.includes(item))

  return {
    isInvalid: invalidFields.length > 0,
    fields: invalidFields.map((field: string) => {
      return { field, message: '' }
    }),
  }
}

export const invalidFieldsMessage = 'Unexpected Fields Received In Response'

// export const history = createBrowserHistory()
